import React, { useEffect, useState } from 'react';
import {
  ACTIVE_GAME_RESOLUTION_ERROR_KEY,
  ACTIVE_GAME_RESOLUTION_EVENT,
} from '../utils/active-game-context';

const ActiveGameRecoveryBanner: React.FC = () => {
  const [unavailable, setUnavailable] = useState(
    () => sessionStorage.getItem(ACTIVE_GAME_RESOLUTION_ERROR_KEY) === '1',
  );

  useEffect(() => {
    const handleResolution = (event: Event) => {
      const detail = (event as CustomEvent<{ unavailable?: boolean }>).detail;
      setUnavailable(Boolean(detail?.unavailable));
    };
    window.addEventListener(ACTIVE_GAME_RESOLUTION_EVENT, handleResolution);
    return () => window.removeEventListener(ACTIVE_GAME_RESOLUTION_EVENT, handleResolution);
  }, []);

  if (!unavailable) return null;

  return (
    <div
      role="status"
      style={{
        position: 'fixed',
        zIndex: 100000,
        top: 12,
        left: '50%',
        transform: 'translateX(-50%)',
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        maxWidth: 'calc(100vw - 24px)',
        padding: '10px 14px',
        borderRadius: 12,
        color: '#fff',
        background: 'rgba(35, 24, 8, 0.96)',
        border: '1px solid rgba(255, 196, 73, 0.65)',
        boxShadow: '0 8px 28px rgba(0, 0, 0, 0.35)',
      }}
    >
      <span>We could not verify your active game. Your reconnect state is preserved.</span>
      <button
        type="button"
        onClick={() => window.location.reload()}
        style={{
          border: 0,
          borderRadius: 8,
          padding: '7px 10px',
          cursor: 'pointer',
          fontWeight: 700,
        }}
      >
        Retry
      </button>
    </div>
  );
};

export default ActiveGameRecoveryBanner;
